export default __webpack_public_path__ + "static/media/3.f90087c9.jpg";